// imports
import Vue from "vue";
import VueRouter from "vue-router";

import store from "@/store";

import routes from "./routes";
import { permissions } from "@/router/middleware/global/permissions";

Vue.use(VueRouter);

const router = new VueRouter({
  routes, // short for routes: routes
  mode: "history",
  linkExactActiveClass: "nav-item active"
});

// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  // If no subsequent Middleware exists,
  // the default `next()` callback is returned.
  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    // Run the default Vue Router `next()` callback first.
    context.next(...parameters);
    // Than run the subsequent Middleware with a new
    // `nextMiddleware()` callback.
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

router.beforeEach((to, from, next) => {
  let middleware = [permissions];

  // For testing
  // return next();

  if (to.meta.middleware) {
    if (Array.isArray(to.meta.middleware)) {
      middleware = to.meta.middleware.concat(middleware);
    } else {
      middleware.unshift(to.meta.middleware);
    }

    const context = {
      from,
      next,
      router,
      to,
      store
    };
    const nextMiddleware = nextFactory(context, middleware, 1);

    return middleware[0]({ ...context, next: nextMiddleware });
  }

  return next();
});

export default router;
